module.exports = __webpack_public_path__ + "static/media/curso-brand.76f9a953.svg";